import ReactDOM from 'react-dom';
import './Styling/App.scss';
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
